import React, { useCallback } from 'react'
import { Button, IconCloseDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { trackBogoPromoModalCloseClicked } from '@mc/pre-paywall-events'
import { BOGO_I18N_NAMESPACE } from '../../../i18n'
import { setIsBogoPromoModalDismissed } from '../isBogoPromoModalDismissed'
import classes from './CloseButton.module.scss'

export const CloseButton = ({
  setShow,
}: {
  setShow: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const { t } = useTranslation(BOGO_I18N_NAMESPACE)

  const handleClick = useCallback(() => {
    setShow(false)

    trackBogoPromoModalCloseClicked()

    setIsBogoPromoModalDismissed()
  }, [setShow])

  return (
    <Button
      className={`mc-modal__close mc-p-0 mc-m-3 ${classes.close}`}
      kind='link'
      onClick={handleClick}
    >
      <IconCloseDefault
        size={2}
        className='mc-text-color--dark'
        srText={t('modal.closeButtonAlt')}
      />
    </Button>
  )
}
